import {Component, OnDestroy, OnInit} from '@angular/core';
import {AsyncPipe, DatePipe, NgClass, NgFor, NgIf } from "@angular/common";
import {ReviewService} from "../../../services/review.service";
import {Observable, of, Subscription} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {SummaryReviewModel, ViewReviewModel} from "../../../models/review";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {UserService} from "../../../services/user.service";

@Component({
    selector: 'app-person-reviews',
    imports: [
        AsyncPipe,
        NgIf,
        MatProgressSpinner,
        NgFor,
        DatePipe,
        NgClass,
    ],
    templateUrl: './person-reviews.component.html'
})

export class PersonReviewsComponent implements OnInit, OnDestroy {
  pId!: string;
  reviews$: Observable<ViewReviewModel[]> = of([]);
  reviewsSub = new Subscription();
  viewReviews!: ViewReviewModel[];
  pagedReviews!: ViewReviewModel[];
  pagingSize: number = 3;
  loadMore: boolean = false;
  summaryReview$: Observable<SummaryReviewModel>;
  fiveStars: number[];

  constructor(private activatedRoute: ActivatedRoute,
              private reviewService: ReviewService,
              private userService: UserService) {
    let paramPersonId = this.activatedRoute.snapshot.paramMap.get('id');
    this.pId = paramPersonId != null ? paramPersonId : '';
    this.reviews$ = this.reviewService.getReviews(this.pId);
    this.summaryReview$ = this.reviewService.getSummaryReview(this.pId);
    this.fiveStars = Array(5).fill(1).map((x, i) => i + 1);
  }

  ngOnInit(): void {
    this.reviewsSub = this.reviews$.subscribe({
      next: response => {
        this.viewReviews  = response;
        if (response.length > 3) {
          this.pagedReviews = response.slice(0, this.pagingSize);
          this.loadMore = true;
        }
        else {
          this.pagedReviews = response;
          this.loadMore = false;
        }
        this.loadImages(this.viewReviews);
      }
    });
  }

  ngOnDestroy(): void {
    this.reviewsSub.unsubscribe();
  }

  protected readonly Array = Array;
  showIcon(index:number, rating:number) {
    if (rating >= index + 1) {
      return '/assets/icons/star-filled.svg';
    } else {
      return '/assets/icons/star-non-filled.svg';
    }
  }

  loadMoreReviews(): void {
    if (this.viewReviews.length > this.pagedReviews.length) {
      let end = this.pagedReviews.length + this.pagingSize;
      this.pagedReviews = this.viewReviews.slice(0, end);
      this.loadMore = true;
    }
    else {
      this.loadMore = false;
    }
  }

  private loadImages(items: ViewReviewModel[]) {
    for (let item of items) {
      this.userService.getAvatarImage(item.reviewAuthorId)
        .subscribe({
          next: (response) => {
            if(response.body != null) {
              item.avatarUrl = URL.createObjectURL(response.body);
            }
          },
          error: (error) => { console.error(error); },
          complete: () => { item.avatarLoaded = true; }
        });
    }
  }

}
